export const categories = [
  {
    slug: "yingshi",
    name: "影视资源",
    description: "电影、电视剧、纪录片、综艺节目等高清影视资源的磁力搜索指南",
    icon: "ri-movie-2-line",
    articleCount: 24,
    imageSeq: "cat-yingshi",
  },
  {
    slug: "ruanjian",
    name: "软件资源",
    description: "各类软件、工具、操作系统的磁力搜索与下载技巧",
    icon: "ri-apps-2-line",
    articleCount: 18,
    imageSeq: "cat-ruanjian",
  },
  {
    slug: "wendang",
    name: "文档资源",
    description: "电子书、学术论文、教程资料等文档类资源的磁力搜索方法",
    icon: "ri-file-text-line",
    articleCount: 15,
    imageSeq: "cat-wendang",
  },
  {
    slug: "yinyue",
    name: "音乐资源",
    description: "无损音乐、专辑合集、演唱会等音乐资源的磁力搜索攻略",
    icon: "ri-music-2-line",
    articleCount: 12,
    imageSeq: "cat-yinyue",
  },
  {
    slug: "youxi",
    name: "游戏资源",
    description: "PC游戏、主机游戏、手游等游戏资源的磁力搜索与下载指南",
    icon: "ri-gamepad-line",
    articleCount: 20,
    imageSeq: "cat-youxi",
  },
  {
    slug: "qita",
    name: "其他资源",
    description: "图片素材、设计资源、模板等综合类资源的磁力搜索技巧",
    icon: "ri-folder-2-line",
    articleCount: 10,
    imageSeq: "cat-qita",
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug) || null;
};